/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProviderDirectoryContactType } from './ProviderDirectoryContactType';
import {
    ProviderDirectoryContactTypeFromJSON,
    ProviderDirectoryContactTypeFromJSONTyped,
    ProviderDirectoryContactTypeToJSON,
} from './ProviderDirectoryContactType';

/**
 * 
 * @export
 * @interface CreateDirectoryContactRequest
 */
export interface CreateDirectoryContactRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateDirectoryContactRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDirectoryContactRequest
     */
    position?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDirectoryContactRequest
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDirectoryContactRequest
     */
    phone?: string | null;
    /**
     * 
     * @type {ProviderDirectoryContactType}
     * @memberof CreateDirectoryContactRequest
     */
    contact_type: ProviderDirectoryContactType;
    /**
     * 
     * @type {string}
     * @memberof CreateDirectoryContactRequest
     */
    user_id?: string | null;
}

/**
 * Check if a given object implements the CreateDirectoryContactRequest interface.
 */
export function instanceOfCreateDirectoryContactRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "contact_type" in value;

    return isInstance;
}

export function CreateDirectoryContactRequestFromJSON(json: any): CreateDirectoryContactRequest {
    return CreateDirectoryContactRequestFromJSONTyped(json, false);
}

export function CreateDirectoryContactRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDirectoryContactRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'position': !exists(json, 'position') ? undefined : json['position'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'contact_type': ProviderDirectoryContactTypeFromJSON(json['contact_type']),
        'user_id': !exists(json, 'user_id') ? undefined : json['user_id'],
    };
}

export function CreateDirectoryContactRequestToJSON(value?: CreateDirectoryContactRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'position': value.position,
        'email': value.email,
        'phone': value.phone,
        'contact_type': ProviderDirectoryContactTypeToJSON(value.contact_type),
        'user_id': value.user_id,
    };
}

